/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setProfilePhoto} from '../api'

export const useMutationSetProfilePhoto = createReactQueryMutationHook('setProfilePhoto', setProfilePhoto)
